import { PortableText, PortableTextComponents } from "@portabletext/react";
import { PortableTextBlock } from "@portabletext/types";
import { urlForImage } from "../../utils/sanityClient";

const components: PortableTextComponents = {
  types: {
    image: ({ value }) => {
      if (!value?.asset) return null;

      return (
        <img
          src={urlForImage(value).width(1400).fit("max").url()}
          alt={value.alt || ""}
          className="my-8 w-full rounded-2xl object-cover"
        />
      );
    },
  },
  marks: {
    link: ({ value, children }) => {
      const href: string | undefined = value?.href;
      const isExternal = !!href && /^https?:\/\//.test(href);

      return (
        <a
          href={href}
          target={isExternal ? "_blank" : undefined}
          rel={isExternal ? "noreferrer" : undefined}
        >
          {children}
        </a>
      );
    },
  },
};

export const BlogBody = ({ value }: { value: PortableTextBlock[] }) => {
  return (
    <div className="markdown blog-content font-onest">
      <PortableText value={value} components={components} />
    </div>
  );
};
